import React from 'react'
import { Header, HTMLText } from '@crossfit/ui'

import InnerContent from 'components/InnerContent'

function SorryCoachPage() {
  return (
    <InnerContent>
      <Header as='h2' size='large' mb={2}>
        Sorry!
      </Header>
      <HTMLText>
        Your affiliate doesn’t have an active CAP subscription. Reach out to
        your owner for more information.
      </HTMLText>
    </InnerContent>
  )
}

export default SorryCoachPage
